import firebaseChatService from '../services/firebaseChatService';
import { chatSdk } from '@wix/chat-sdk';
import wix from '../services/wix';
import { ThunkExtraArgument } from '../store/configureStore';
import { initApp } from './serverApi';
import { updateAllowInput, updateHasMessages } from './index';
import { loadingScheduler } from '../services/loading-scheduler';
import { isExperimentOn } from '../reducers';

const handlers = {
  onVisitorMerge: event => (dispatch, getState) => {
    if (event.mergedIntoChatroomId) {
      dispatch(updateAllowInput(true));
    }

    if (
      !event.mergedIntoChatroomId ||
      event.mergedIntoChatroomId === event.visitorChatroomId
    ) {
      return;
    }

    chatSdk.disconnect();

    return dispatch(
      initApp({
        reconnectData: {
          refresh: true,
          oldVisitorInstanceId: firebaseChatService.visitorInstanceId,
          prevChatToken: getState().coreChatToken,
        },
      }),
    );
  },
  onNewMessage: event => (dispatch, getState) => {
    if (isExperimentOn(getState(), 'specs.chat.LazilyInteractiveWidget')) {
      void loadingScheduler.triggerInteractivity();
      return dispatch(updateHasMessages(true));
    }
  },
};

const handleIncomingEvents = event => {
  return function(dispatch, getState) {
    if (event.type === 'VisitorMerge') {
      return dispatch(handlers.onVisitorMerge(event));
    }

    if (
      event.type === 'Activity' &&
      event.activity.direction === 'BUSINESS_TO_CUSTOMER'
    ) {
      return dispatch(handlers.onNewMessage(event));
    }
  };
};

interface InitFirebaseParams {
  initData: {
    authKey: string;
    options: object;
    messagePath: string;
    presencePath: string;
    visitorInstanceId: string;
    visitorId: string;
    correlationId: string;
  };
  deviceType: string;
  location: string;
  timestamp: number;
  derivedChatroomId: string;
}

export const initFirebase = (action: InitFirebaseParams) => {
  return async function(
    dispatch,
    getState,
    { visitCount }: ThunkExtraArgument,
  ) {
    const {
      authKey,
      options,
      messagePath,
      presencePath,
      visitorInstanceId,
      visitorId,
      correlationId,
    } = action.initData;
    const { deviceType, location, timestamp, derivedChatroomId } = action;
    await firebaseChatService.init({
      authKey,
      options,
      eventPath: messagePath,
      presencePath,
      shouldSetAuthToNone: getState().experiments[
        'specs.chat.FirebasePersistenceNone'
      ],
      biToken: wix.getBiToken(),
      visitorId,
      visitorInstanceId,
      correlationId,
    });
    firebaseChatService.subscribeToEventsAndInfo({
      eventCallback: events => dispatch(handleIncomingEvents(events)),
      timestamp,
    });
    firebaseChatService.reportPresenceSummaryEvents();
    firebaseChatService.removeOnDisconnect();
    visitCount.getVisitCount().then(_visitCount => {
      firebaseChatService.updatePresence({
        deviceType,
        location,
        timestamp,
        visitCount: _visitCount,
        derivedChatroomId,
      });
    });
  };
};
